module.exports = __webpack_public_path__ + "media/images/common/list_ore-2cfb2a5f576632837e51dfa565843cad.gif";